import React from "react";
import { CircularProgress, Fab, Zoom, styled, useTheme } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ICertificationUploadProps } from "./schoolCertificationModel";

const VisuallyHiddenInput = styled('input')({
  width: '100%',
  opacity: 0,
  position: 'absolute',
  height: '100%',
  cursor: 'pointer',
  top: 0,
  left: 0,
});

export const CertificationFileUploadComponent: React.FC<ICertificationUploadProps> = ({ handleFileChange, fileUploadIsInProgress }) => {
  const theme = useTheme();

  return (
    <Zoom in timeout={theme.transitions.duration.enteringScreen}>
      <Fab
        variant="extended"
        color="primary"
        disabled={fileUploadIsInProgress}
        sx={{
          position: 'fixed',
          bottom: 36,
          right: 36,
          gap: 1,
          px: 3,
          animation: fileUploadIsInProgress ? 'none' : undefined,
        }}
      >
        {fileUploadIsInProgress
          ? <CircularProgress size={20} color="inherit" />
          : <CloudUploadIcon />
        }
        {fileUploadIsInProgress ? 'Uploading…' : 'Add Files'}
        {!fileUploadIsInProgress && (
          <VisuallyHiddenInput type="file" onChange={handleFileChange} />
        )}
      </Fab>
    </Zoom>
  );
};